import React from 'react';
import { MenuItem } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { IconName } from '@fortawesome/fontawesome-svg-core';

export type ContextualMenuItemProps = {
    label: string;
    icon?: IconName;
    onClick: () => void;
};

const ContextualMenuItem: React.FunctionComponent<ContextualMenuItemProps> = function (props) {
    const { label, icon, onClick } = props;

    const menuSx = {
        display: 'flex',
        columnGap: '10px',
        fontSize: '14px',
    };

    const iconSx = {
        display: 'flex',
        lineHeight: 1,
        fontSize: '14px',
    };

    return (
        <MenuItem
            data-testid="contextual-menu-item"
            sx={menuSx}
            onClick={onClick}
        >
            {icon && (
                <FaOptionIcon
                    sx={iconSx}
                    icon={['fasl', icon]}
                />
            )}
            {label}
        </MenuItem>
    );
};

export default ContextualMenuItem;
